import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, Renderer2, NgZone } from '@angular/core';
import { Subscription, Subject, fromEvent } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { v_QuoteNoteBus } from '@app/cp/shared/models/v_QuoteNoteBus';
import { QuoteService } from '@app/cp/shared/services/quote.service';
import { NoteUpd } from '@app/cp/shared/models/NoteUpd';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { QuoteNoteBus } from '@app/cp/shared/models/QuoteNoteBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { BaseGridEditFormLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-formlines.component';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { tap, take, takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
const matches = (el, selector) => (el.matches || el.msMatchesSelector).call(el, selector);

@Component({
    selector: 'quote-notes',
    templateUrl: './quote-notes.component.html',
    styleUrls: ['./quote-notes.component.scss'],
    standalone: false
})
export class QuoteNotesComponent extends BaseGridEditFormLinesComponent<v_QuoteNoteBus, null, QuoteService> {
    @Output() showDispatch: EventEmitter<any> = new EventEmitter<any>();
    @Input() ShowDispatchPopup: boolean = false;
    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();

    private destroy$ = new Subject();
    private currentSubscription: Subscription;
    rowLine: number;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, private zone: NgZone, svc_data: QuoteService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "v_QuoteNoteBus";
        this.appCode = "QuoteNotes";
        this.disableCpSearchDialog();
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'quoteNoteId': new UntypedFormControl(),
            'quoteId': new UntypedFormControl(),
            'quoteNotes': new UntypedFormControl(),
            'quoteNotePersonId': new UntypedFormControl(),
            'personName': new UntypedFormControl(),
            'isPrintable': new UntypedFormControl(),
            'sortOrder': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),

        });
    }
    setForm() {
        this.editForm.patchValue({
            quoteNoteId: this.selectedData.quoteNoteId,
            quoteId: this.selectedData.quoteId,
            quoteNotes: this.selectedData.quoteNotes,
            quoteNotePersonId: this.selectedData.quoteNotePersonId,
            personName: this.selectedData.personName,
            isPrintable: this.selectedData.isPrintable,
            sortOrder: this.selectedData.sortOrder,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId
        });
        this.notes = CommonFunctions.getStringValueIfNull(this.selectedData.quoteNotes);
    }
    setFromReferenceData(data: v_QuoteNoteBus) {
        data.personName = this.personName(data.quoteNotePersonId);
        return data;
    }
    setFromNonFormData(data: v_QuoteNoteBus) {
        data.quoteNotes = this.notes;
        return data;
    }
    notesPersonId(dataItem: v_QuoteNoteBus = null): any {
        dataItem = !dataItem ? this.selectedData : dataItem;
        return dataItem ? dataItem.quoteNotePersonId : null;
    }
    protected getChangedObject(data: v_QuoteNoteBus) {
        let busObj: QuoteNoteBus = new QuoteNoteBus(data);
        if (!CommonFunctions.hasGuidValue(busObj.quoteNotePersonId)) {
            busObj.quoteNotePersonId = this.globals.personId; // busObj.updateUserId;
        }
        busObj.setBeforeSave();
        return busObj;
    }

    protected save(dataObj: v_QuoteNoteBus) {

        let busObj: QuoteNoteBus = this.getChangedObject(dataObj); // new QuoteNoteBus(dataObj);
        //if (!CommonFunctions.hasGuidValue(busObj.quoteNotePersonId)) {
        //    busObj.quoteNotePersonId = this.globals.personId; // busObj.updateUserId;
        //}
        this.svc_data.saveQuoteNote(busObj).subscribe((data: QuoteNoteBus) => {
            if (data != null) {
                let newDataObj: v_QuoteNoteBus = new v_QuoteNoteBus(data);
                newDataObj.personName = this.personName(newDataObj.quoteNotePersonId);
                this.saveSuccess(newDataObj);
            }
            else {
                this.saveError(dataObj, CommonValues.Message_ErrorSaving);
            }
        });
    }

    deleteIndividual(data: v_QuoteNoteBus) {
        if (data.hasId) {
            this.svc_data.deleteQuoteNote(data.quoteNoteId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    let delDataObj: v_QuoteNoteBus = new v_QuoteNoteBus(data);

                    this.deleteSuccess(delDataObj);
                    this.removeLocal(delDataObj);
                }
                else {
                    this.deleteError(data, dataObj.message);

                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "isPrintable") {
            this.editForm.patchValue({
                isPrintable: e.target.checked
            });

        }

    }
    rowClassFunction(context: RowClassArgs) {
        if (context.dataItem.isDraged) {
            return { isDraged: true }
        }
    }
    popupDispatch() {

        this.showDispatch.emit(null);
    }
    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.currentSubscription);
    }
    get canEditNote(): boolean {
        let can: boolean = false;

        if (this.canEdit && this.selectedData) {
            if (this.selectedData.quoteNotePersonId == this.globals.personId || this.rights.EditOthersNotes) {
                can = true;
            }
        }

        return can;
    }
    canDeleteNote(dataItem: v_QuoteNoteBus): boolean {
        let can: boolean = false;

        if (this.canEdit && dataItem) {
            if (dataItem.quoteNotePersonId == this.globals.personId || this.rights.EditOthersNotes) {
                can = true;
            }
        }

        return can;
    }

    tableRow = node => node.tagName.toLowerCase() === 'tr';
    closest = (node, predicate) => {
        while (node && !predicate(node)) {
            node = node.parentNode;
        }

        return node;
    };
    processGridData() {
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (!this.gridData[i].personName) {
                    this.gridData[i].personName = this.personName(this.gridData[i].quoteNotePersonId);
                }
            }
        }
        this.getDragReady();
    }
    getDragReady() {

        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }
        //  if (this.canDrag) {
        this.zone.onStable.pipe(take(1))
            .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        // }
    }

    handleDragAndDrop(): Subscription {

        const sub = new Subscription(() => { });

        let draggedItemIndex;
        let dropItemIndex;
        let remoteDropItemIndex;
        let droplocation;
        let overCnt: number = 0;
        var inEditMode = "true";
        if (this.editForm) { inEditMode = "false"; }
        const tableRows = Array.from(document.querySelectorAll('div.quoteNoteGridDiv > .k-grid tr'));
        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            const dragLeave = fromEvent(item, 'dragleave');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(takeUntil(this.destroy$)).pipe(
                tap(({ dataTransfer }) => {
                    try {

                        //const dragImgEl = document.createElement('span');
                        //dragImgEl.setAttribute('style', 'position: absolute; display: block; top: 0; left: 0; width: 0; height: 0;');
                        //document.body.appendChild(dragImgEl);
                        //dataTransfer.setDragImage(dragImgEl, 0, 0);
                    } catch (err) {
                        // IE doesn't support setDragImage
                    }
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid.data);
                dataItem = data.data[draggedItemIndex];
                //   dataItem.dragging = true;
            }));
            sub.add(dragLeave.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {

                const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target
                const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                const row2: HTMLTableRowElement = <HTMLTableRowElement>row.parentElement;
                const row3: HTMLTableRowElement = <HTMLTableRowElement>row2.parentElement;
                const dropIndex = this.closest(row, this.tableRow).rowIndex;
                if (remoteDropItemIndex == dropIndex) {
                    remoteDropItemIndex = null;

                    this.rowLine = null;
                }
                if (dropItemIndex == dropIndex) { dropItemIndex = null; }

            }));
            sub.add(dragOver.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>e.target;
                const dropIndex = this.closest(row, this.tableRow).rowIndex;
                this.rowLine = dropIndex;
                remoteDropItemIndex = dropIndex;

            }));

            sub.add(dragEnd.subscribe((e: any) => {
                e.preventDefault();
                var event = _.cloneDeep(dataItem);
                event.detailType = 4;
                event.detailSource = "Q";
                event.dropid = event.quoteNoteId

                this.dropEvent.emit(event);
                // const dataItem = this.gridData.data[draggedItemIndex];
                //   dataItem.dragging = false;
            }));
        });

        return sub;
    }
    //popupDispatch() {

    //    this.showDispatch.emit(null);
    //}
    insertRow() {

        if (this.rowLine >= 0) {
            var inrow = new v_QuoteNoteBus();
            this.zone.run(() => {
                this.gridData.splice(this.rowLine, 0, inrow);
            }

            );

            if (this.grid && this.grid.pageSize && this.hasGridData) {
                this.grid.data = {
                    data: this.gridData.slice(this.grid.skip, this.grid.skip + this.grid.pageSize),
                    total: this.gridData.length
                };
            }
            this.cd.detectChanges();
            // this.gridData.splice(this.rowLine, 0, inrow);
            //   this.rowLine = null;
            //this.dataStateChange(null);
            //this.redoSortOrder();
            //this.redoSortOrder();
        }

    }
    redoSortOrder() {
        let sort: number = 1;
        this.zone.run(() => {
            for (let e of this.gridData) {
                e.sortOrder = sort++;
                e.isUpdated = true;
            }
        });
        //    this.sendParentMessage(MessageType.changed);
    }
    updateRow(dataItem: v_QuoteNoteBus) {

        if (this.rowLine >= 0) {
            var inrow = new v_QuoteNoteBus(dataItem);
            inrow.isDraged = true;
            this.zone.run(() => {
                this.gridData.splice(this.rowLine, 1, inrow);
            }
            );
            this.gridData.splice(this.rowLine, 1, inrow);
            this.rowLine = null;
            this.dataStateChange(null);
            this.redoSortOrder();
            if (this.grid && this.grid.pageSize && this.hasGridData) {
                this.grid.data = {
                    data: this.gridData.slice(this.grid.skip, this.grid.skip + this.grid.pageSize),
                    total: this.gridData.length
                };
            }
            this.cd.detectChanges();
            //this.redoSortOrder();
        }
    }
    public canDrop() {

        if (this.rowLine) { return true }
        if (this.rowLine == 0) { return true }
        return false;

    }
    dataStateChange(e: any): void {
        this.getDragReady();

    }

}

